import React from 'react';
import { Section } from './ui/Section';
import { useLanguage } from '../context/LanguageContext';
export function PatternInterrupt() {
  const {
    t
  } = useLanguage();
  return <Section className="text-center" data-id="element-62">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-63">
        <h2 className="font-serif text-3xl md:text-5xl leading-tight text-white" data-id="element-64">
          {t.patternInterrupt.headline.line1} <br data-id="element-65" />
          <span className="text-luxury-gold italic" data-id="element-66">
            {t.patternInterrupt.headline.span}
          </span>
        </h2>

        <div className="w-px h-16 bg-gradient-to-b from-transparent via-luxury-gold to-transparent mx-auto" data-id="element-67" />

        <div className="space-y-6 text-lg md:text-xl font-light text-luxury-gray leading-relaxed" data-id="element-68">
          {t.patternInterrupt.bullets.map((bullet, i) => <p key={i} className={i === t.patternInterrupt.bullets.length - 1 ? 'text-white font-medium' : ''} data-id="element-69">
              {bullet}
            </p>)}
        </div>

        <div className="p-8 border border-luxury-gold/20 bg-luxury-charcoal/30 mt-8" data-id="element-70">
          <p className="text-xl md:text-2xl text-white font-serif italic mb-4" data-id="element-71">
            "{t.patternInterrupt.quote.text}"
          </p>
          <p className="text-luxury-gray" data-id="element-72">{t.patternInterrupt.quote.sub}</p>
        </div>
      </div>
    </Section>;
}